const theme = {
    // colors
    primaryColor: "red",

    // text colors
    textDark: "#333",
    textBlack: "#000",

    // responsive breakpoints
    breakpoints: {
        sm_min: 576,
        sm_max: 575,

        md_min: 768,
        md_max: 767,

        lg_min: 992,
        lg_max: 991,

        xl_min: 1200,
        xl_max: 1199,
    },
};

export default theme;
